import React from 'react'
import DashboardHeader from './dashboard_header/DashboardHeader'
import DashboardContracts from './dashboard_contracts/DashboardContracts'
import { useMediaQuery } from 'react-responsive'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import styles from '../../styles'
import DashboardNews from './dashboard_news/News'
import DashboardServices from './dashboard_services/Services'
import PreparezArrivee from './preparezArrivee/PreparezArrivee'
import PreparezDepart from './preparezDepart/PreparezDepart'
import { EDLProvider } from './edl/context/EDLContext'

const useStyle = makeStyles((theme) => {
	return {
		...styles(theme),
		dashboardStyle: {
			padding: '0 15px 15px',
			boxSizing: 'border-box'
		},
		dashboardLargeScreenStyle: {
			'& .leftSide': {
				width: '66%',
				marginRight: 40
			}
		},
		dashboardSmallScreenStyle: {
			flexDirection: 'column-reverse'
		}
	}
})

const Dashboard = () => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const dashboardClass = classNames(
		{
			[classes.dashboardLargeScreenStyle]: isLargeScreen,
			[classes.dashboardSmallScreenStyle]: !isLargeScreen
		},
		classes.dashboardStyle,
		classes.flex
	)

	return (
		<>
			<DashboardHeader />
			<EDLProvider>
				<>
					<PreparezArrivee />
					<PreparezDepart />
				</>
			</EDLProvider>

			<div className={dashboardClass}>
				<div className="leftSide">
					<DashboardNews />

					<DashboardServices />
				</div>

				<DashboardContracts
					isLargeScreen={isLargeScreen}
				/>
			</div>
		</>
	)
}

export default Dashboard
